var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwitter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 34,
    viewBox: "0 0 42 34",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.05 5.352c1.78-1.058 3.146-2.732 3.79-4.727-1.665.979-3.51 1.69-5.472 2.073C33.796 1.038 31.557 0 29.078 0c-4.759 0-8.617 3.826-8.617 8.544 0 .67.077 1.322.223 1.947-7.161-.356-13.51-3.758-17.76-8.927-.742 1.262-1.167 2.73-1.167 4.295 0 2.965 1.522 5.58 3.834 7.112-1.413-.044-2.742-.429-3.903-1.069l-.001.108c0 4.14 2.97 7.593 6.912 8.378-.723.195-1.484.3-2.27.3-.555 0-1.095-.054-1.621-.154 1.096 3.395 4.278 5.865 8.049 5.934-2.949 2.291-6.664 3.657-10.701 3.657-.696 0-1.382-.04-2.056-.119 3.813 2.424 8.343 3.839 13.209 3.839 15.85 0 24.516-13.02 24.516-24.31 0-.37-.008-.74-.025-1.106 1.684-1.204 3.145-2.71 4.3-4.423-1.545.68-3.206 1.14-4.95 1.346z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/twitter.9921639955b4a8e3639fca79a8faf72d.svg";